export const Details = () => import("./Details.vue");
export const MyPending = () => import("./MyPending.vue");
export const PreSanction = () => import("./PreSanction.vue");
export const PreSanctionApproved = () => import("./PreSanctionApproved.vue");
export const PreSanctionCashInProcess = () => import("./PreSanctionCashInProcess.vue");
